import BrieIconGreenOutlined from "./BrieIconGreenOutlined";

export default function BrieChatEmptyState() {
  return (
    <div className="brie-intro-container w-100">
      <div className="d-flex flex-column align-items-center w-100">
        <div>
          <BrieIconGreenOutlined transform="scale(1.3)" />
        </div>
        <h3 className="mt-2 mb-3">Hello! How can I help you today?</h3>
        <div className="d-flex flex-column gap-2 w-100">
          <RecommendationCard
            icon="mdi mdi-tab-search"
            title="Search"
            description="Ex: Get the companies created today"
          />
          <RecommendationCard
            icon="mdi mdi-sort"
            title="Sort"
            description="Ex: Sort by company name"
          />
          <RecommendationCard
            icon="mdi mdi-newspaper-variant-outline"
            title="Create"
            description="Ex: Create a new company"
          />
          <RecommendationCard
            icon="mdi mdi-run-fast"
            title="Navigation"
            description="Ex: Go to my data sources"
          />
          <RecommendationCard
            icon="mdi mdi-chat-question"
            title="Chat"
            description="Ask anything! Ex: Please draft a sample letter"
          />
        </div>
      </div>
    </div>
  );
}

function RecommendationCard({
  icon,
  title,
  description,
}: {
  icon: string;
  title: string;
  description: string;
}) {
  return (
    <div className="d-flex align-items-center rounded-sm btn-oauth w-100 px-3 py-2 border border-superlight">
      <div>
        <i className={`${icon}`} style={{ fontSize: 32 }} />
      </div>
      <div className="d-flex flex-column justify-content-center ml-3">
        <h4 className="mb-0">{title}</h4>
        <p className="m-0 p-0 text-xs">{description}</p>
      </div>
    </div>
  );
}
